import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=0c786db8&scoped=true"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"
import style0 from "./comment.vue?vue&type=style&index=0&id=0c786db8&prod&scoped=true&lang=css"
import style1 from "./comment.vue?vue&type=style&index=1&id=0c786db8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c786db8",
  null
  
)

export default component.exports